import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Profile, Signer, Staking } from '@tokenlon/sdk';
import { axios } from "../common";
var ONE_DAY_SECONDS = 24 * 60 * 60;
export var getStakingDashboard = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(chainId) {
    var staking;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (chainId) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            staking = new Staking(chainId);
            return _context.abrupt("return", staking.fetchStakingDashboard());

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getStakingDashboard(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getOneWeekApy = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(chainId) {
    var now, start, end, staking;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (chainId) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            now = Math.floor(new Date().getTime() / 1000);
            start = now - 7 * ONE_DAY_SECONDS;
            end = now + ONE_DAY_SECONDS;
            staking = new Staking(chainId);
            return _context2.abrupt("return", staking.fetchOneWeekApy(start, end));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getOneWeekApy(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var getOneMonthApy = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chainId) {
    var now, start, end, staking;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (chainId) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            now = Math.floor(new Date().getTime() / 1000);
            start = now - 30 * ONE_DAY_SECONDS;
            end = now + ONE_DAY_SECONDS;
            staking = new Staking(chainId);
            return _context3.abrupt("return", staking.fetchOneMonthApy(start, end));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getOneMonthApy(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var getAllApy = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(chainId) {
    var now, start, end, staking;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (chainId) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            now = Math.floor(new Date().getTime() / 1000);
            start = 0;
            end = now + ONE_DAY_SECONDS;
            staking = new Staking(chainId);
            return _context4.abrupt("return", staking.fetchAllApy(start, end));

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getAllApy(_x4) {
    return _ref4.apply(this, arguments);
  };
}(); // 质押 Lon

export var postStake = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(provider, amount, callback) {
    var signer, txRaw;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!provider || !amount)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            signer = new Signer(provider, 'web', {
              afterProcessEthTx: callback
            });
            _context5.next = 5;
            return signer.sendStakeWithPermit(amount);

          case 5:
            txRaw = _context5.sent;
            return _context5.abrupt("return", signer.sendTransaction(txRaw));

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function postStake(_x5, _x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}(); // 解锁 xLon，解锁后进入赎回冷静期

export var postUnstake = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(provider, callback) {
    var signer, txRaw;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (provider) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            signer = new Signer(provider, 'web', {
              afterProcessEthTx: callback
            });
            _context6.next = 5;
            return signer.sendUnstake();

          case 5:
            txRaw = _context6.sent;
            return _context6.abrupt("return", signer.sendTransaction(txRaw));

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function postUnstake(_x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}(); // 判断赎回是否有冷静期

export var getStakingCoolDown = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(provider, address) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(!provider || !address)) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context7.abrupt("return", profile.stakersCooldowns(address).then(Number));

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getStakingCoolDown(_x10, _x11) {
    return _ref7.apply(this, arguments);
  };
}(); // 获取赎回冷静期时间（in seconds）

export var getStakingCoolDownRemainSeconds = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(provider, address) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(!provider || !address)) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context8.abrupt("return", profile.cooldownRemainSeconds(address).then(Number));

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getStakingCoolDownRemainSeconds(_x12, _x13) {
    return _ref8.apply(this, arguments);
  };
}(); // 赎回冷静期结束后，进行赎回 Lon

export var postRedeem = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(provider, amount, callback) {
    var signer, txRaw;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(!provider || !amount)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            signer = new Signer(provider, 'web', {
              afterProcessEthTx: callback
            });
            _context9.next = 5;
            return signer.sendRedeem(amount);

          case 5:
            txRaw = _context9.sent;
            return _context9.abrupt("return", signer.sendTransaction(txRaw));

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function postRedeem(_x14, _x15, _x16) {
    return _ref9.apply(this, arguments);
  };
}(); // 赎回冷静期未结束时，获得强制赎回 Lon 的罚金预览

export var getRageExitPreview = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(provider, address) {
    var profile;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!(!provider || !address)) {
              _context10.next = 2;
              break;
            }

            return _context10.abrupt("return");

          case 2:
            profile = new Profile(provider);
            return _context10.abrupt("return", profile.previewRageExit(address));

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function getRageExitPreview(_x17, _x18) {
    return _ref10.apply(this, arguments);
  };
}(); // 赎回冷静期未结束时，进行强制赎回 Lon

export var postRageExit = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(provider, callback) {
    var signer, txRaw;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (provider) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return");

          case 2:
            signer = new Signer(provider, 'web', {
              afterProcessEthTx: callback
            });
            _context11.next = 5;
            return signer.sendRageExit();

          case 5:
            txRaw = _context11.sent;
            return _context11.abrupt("return", signer.sendTransaction(txRaw));

          case 7:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function postRageExit(_x19, _x20) {
    return _ref11.apply(this, arguments);
  };
}(); // 获取质押赎回历史

export var getStakingList = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(chainId, address, page, pageSize) {
    var staking;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!(!chainId || !address)) {
              _context12.next = 2;
              break;
            }

            return _context12.abrupt("return");

          case 2:
            staking = new Staking(chainId);
            return _context12.abrupt("return", staking.fetchStakingList(address, page, pageSize));

          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getStakingList(_x21, _x22, _x23, _x24) {
    return _ref12.apply(this, arguments);
  };
}();
export var getStakingListTotal = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(chainId, address) {
    var _list$length;

    var staking, list;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!(!chainId || !address)) {
              _context13.next = 2;
              break;
            }

            return _context13.abrupt("return");

          case 2:
            staking = new Staking(chainId);
            _context13.next = 5;
            return staking.fetchStakingList(address, 1, 1000);

          case 5:
            list = _context13.sent;
            return _context13.abrupt("return", (_list$length = list === null || list === void 0 ? void 0 : list.length) !== null && _list$length !== void 0 ? _list$length : 0);

          case 7:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getStakingListTotal(_x25, _x26) {
    return _ref13.apply(this, arguments);
  };
}();
export var getAllStakedDayAmounts = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(chainId) {
    var now, start, end, staking;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (chainId) {
              _context14.next = 2;
              break;
            }

            return _context14.abrupt("return");

          case 2:
            now = Math.floor(new Date().getTime() / 1000);
            start = 0;
            end = now + ONE_DAY_SECONDS;
            staking = new Staking(chainId);
            return _context14.abrupt("return", staking.fetchAllStakedDayAmounts(start, end));

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getAllStakedDayAmounts(_x27) {
    return _ref14.apply(this, arguments);
  };
}();
export var getLonCirculation = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", axios.get('/referral/lon/staking/circulation'));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function getLonCirculation() {
    return _ref15.apply(this, arguments);
  };
}();
export var getLonStakedAmounts = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", axios.get('/referral/lon/staked_amounts'));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getLonStakedAmounts() {
    return _ref16.apply(this, arguments);
  };
}();
export var getStakingApyAndScale = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", axios.get('/referral/lon/staking/apy'));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function getStakingApyAndScale() {
    return _ref17.apply(this, arguments);
  };
}();